import React from "react";

import { FloatingMenu } from "@zapier/design-system";
import { Typeahead } from "@zapier/design-system";

import countries, { CountryOption } from "./countries";

type Props = {
  /** Show Error Styling */
  hasError?: boolean;
  /** Id of label element */
  labelId?: string;
  /** Handle item change */
  onChange: (event: CountryOption) => void;
  /** Initial value */
  value?: string;
};

const CountrySelect: React.FC<Props> = ({
  hasError,
  labelId,
  onChange,
  value,
}) => {
  const initialValue = value ? countries.find(c => c.code === value) : null;

  return (
    <Typeahead
      ariaLabel="country"
      filterItems={(inputValue, items: CountryOption[]) => {
        if (!inputValue) return items;

        const lowerCaseInput = inputValue.toLowerCase();

        return items.filter(item =>
          `${item.name} ${item.code} ${item.alternativeSpellings}`
            .toLowerCase()
            .includes(lowerCaseInput)
        );
      }}
      getKeyForItem={item => item.code}
      getLabelForItem={item => item.name}
      initialSelectedItem={initialValue}
      isErrored={hasError}
      items={countries}
      labelId={labelId}
      menuAriaLabel="address countries"
      onChange={onChange}
      openOnFocus={true}
      placeholder="Select a country..."
      renderFloatingMenu={props => (
        <FloatingMenu {...props} visibleItems={1.75} />
      )}
    />
  );
};

export default CountrySelect;
